import { CircularProgress } from '@mui/material'

import SPDCortexVideo from './SPDCortexVideo/SPDCortexVideo'

import useSPDCortexScanner from './SPDCortexScanner.logic'
import { CortexDecoderProvider } from 'lib/scanner/compatibility'

const SPDCortexScanner = ({
  canScan,
  onScan,
}: {
  canScan: boolean
  onScan: (code: string) => void
}) => {
  const { handleScan, currentScan, setCurrentScan } = useSPDCortexScanner({
    onScan,
  })

  return (
    <CortexDecoderProvider
      onScan={canScan ? handleScan : () => {}}
      currentScan={currentScan}
      setCurrentScan={setCurrentScan}
    >
      {canScan ? <SPDCortexVideo onScan={handleScan} /> : <CircularProgress />}
    </CortexDecoderProvider>
  )
}

export default SPDCortexScanner
